import $ from 'jquery';
import {Functions} from '../helpers';

export class Support {

    constructor(App) {
        Support.App = App;
        Support.UI = App.PwnUI;
        Support.settings = App.settings;
        this.initialize();
    };

    initialize() {
        var $scrollBtn = $('.scroll-btn');
        var $height = 0;

        if ($('select.select2').length != 0) {
            $('select.select2').select2();
        }

        $scrollBtn.on('click', function (e) {
            if (e) {
                e.preventDefault();
            }

            $height = $(this).parent().parent().outerHeight(true) + 90;

            $('html, body').animate({
                scrollTop: $height
            }, 1000);
            return false;

        });

        var $question = $('.c-question-field__header');

        $question.on('click', function (e) {
            if (e) {
                e.preventDefault();
            }

            var $parent = $(this).parent();

            if ($parent.hasClass('open')) {
                $parent.removeClass('open');
            } else {
                $('.open').removeClass('open');
                $parent.addClass('open');
            }
        });

        var $roadMenuLinks = $('.road-map-link');

        $roadMenuLinks.each(function () {
            var $target = $(this).attr('href');
            $($target).addClass('active');
        });

        $('.woocommerce-terms-and-conditions').remove();

        // console.log( $checkoutTermsLink, 'Terms Link');

        var $checkoutTermsLink = $('a.woocommerce-terms-and-conditions-link');
        $checkoutTermsLink.off('click');
        $checkoutTermsLink.on('click', function (e) {
            e.preventDefault();
            var url = $checkoutTermsLink.attr('href');
            window.open(url, '_blank');
        });

        /*var $label7 = $('.wpcf7-list-item-label');
        $label7.each(function () {
            $(this).on('click', function (e) {
                $(this).parent().find('input').click();
            });
        });

        var $radios = $('input[type="radio"]');
        $radios.each(function () {

            if ($(this).parent().parent().hasClass('wpcf7-radio')) {
                if ($(this).attr('checked')) {
                    //$('.checkmark').removeClass('active');
                    $(this).parent().find('.wpcf7-list-item-label').addClass('tc-black');
                    $(this).parent().parent().parent().parent().find('.checkmark').addClass('active');
                }
                $(this).on('click', function (e) {
                    $(this).parent().parent().parent().parent().parent().find('.checkmark').removeClass('active');
                    $(this).parent().parent().parent().parent().parent().find('.wpcf7-list-item-label').removeClass('tc-black');
                    $(this).parent().parent().parent().parent().find('.checkmark').addClass('active');
                    $(this).parent().find('.wpcf7-list-item-label').addClass('tc-black');
                });
            }
            //console.log( this );
        });*/

        var $checkmarks = $('.checkmark');
        $checkmarks.each(function () {
            $(this).on('click', function (e) {
                if ($(this).parent().find('span').hasClass('.wpcf7-radio')) {
                    $(this).parent().parent().find('.checkmark').removeClass('active');
                    $(this).addClass('active');
                    $(this).parent().parent().find('.wpcf7-list-item-label').removeClass('tc-black');
                    $(this).parent().find('.wpcf7-list-item-label').addClass('tc-black');
                }
            });
        });

        var $documents = [];

        $('#user_documents').on('change', function () {
            var $list = $('#documents_list');
            var $this = $('#user_documents')[0];
            var reader = new FileReader();

            var $type = $this.files[0].type.split("/")[1];

            reader.onload = function (e) {
                if ($type == 'pdf') {
                    $list.prepend('<div class="col-xs-12 col-sm-6 col-md-3"><div class="mt-30">' + $this.files[0].name + '</div></div>');
                } else if ($type == 'jpeg' || $type == 'png') {
                    $list.prepend('<div class="col-xs-12 col-sm-6 col-md-3"><img class="mt-30" src="' + e.target.result + '"></div>');
                }
            };
            $documents.push($this.files);
            reader.readAsDataURL($this.files[0]);
        });

        if (($('#buyer_signature').length > 0) && ($('#signed').length > 0)) {
            var $this = $('#buyer_signature');
            var $src = $('#signed').next().attr('src');
            $('#buyer_signature').attr('src', $src);
            $('#signed').parent().prev().hide();
            $('#signed').parent().hide();
        }

        document.addEventListener( 'wpcf7grecaptchaexecuted', event => {
            const fields = document.querySelectorAll(
                'form.register input[name="_sp_recaptcha_response"]'
            );

            for ( let i = 0; i < fields.length; i++ ) {
                let field = fields[ i ];
                field.setAttribute( 'value', event.detail.token );
            }
        } );
    };
}

